import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Trophy } from 'lucide-react';

export const RewardsSkeleton = () => {
  return (
    <div className="p-1 space-y-6 bg-slate-50/30">
      <Card className="rounded shadow p-4">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2 text-xl font-semibold mb-4">
            <Trophy className="h-5 w-5 text-yellow-500" />
            Rewards & Incentives
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Quarterly Metrics Skeleton */}
          <div className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[...Array(3)].map((_, i) => (
                <div key={i} className="bg-slate-50/50 p-6 rounded-xl">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="h-8 w-8 bg-slate-200 animate-pulse rounded-lg" />
                    <div className="h-4 w-24 bg-slate-200 animate-pulse rounded" />
                  </div>
                  <div className="mt-4 mb-2">
                    <div className="h-8 w-32 bg-slate-200 animate-pulse rounded" />
                  </div>
                  <div className="h-4 w-36 bg-slate-200 animate-pulse rounded" />
                </div>
              ))}
            </div>

            {/* Progress Bars Skeleton */}
            <div className="space-y-4 bg-white p-6 rounded-xl">
              {[...Array(2)].map((_, i) => (
                <div key={i}>
                  <div className="flex justify-between mb-2">
                    <div className="h-4 w-24 bg-slate-200 animate-pulse rounded" />
                    <div className="h-4 w-12 bg-slate-200 animate-pulse rounded" />
                  </div>
                  <div className="w-full h-2 bg-slate-200 animate-pulse rounded-full" />
                </div>
              ))}
            </div>
          </div>

          {/* Weekly Incentives Skeleton */}
          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div className="h-6 w-48 bg-slate-200 animate-pulse rounded" />
              <div className="h-4 w-32 bg-slate-200 animate-pulse rounded" />
            </div>

            <div className="bg-slate-50/50 p-6 rounded-xl mb-6">
              <div className="flex items-center justify-between mb-4">
                <div className="flex items-center gap-2">
                  <div className="h-8 w-8 bg-slate-200 animate-pulse rounded-lg" />
                  <div className="h-4 w-36 bg-slate-200 animate-pulse rounded" />
                </div>
                <div className="h-8 w-24 bg-slate-200 animate-pulse rounded" />
              </div>
            </div>

            <div className="bg-white rounded-xl">
              <div className="flex items-center gap-2 p-4 border-b">
                <div className="h-4 w-4 bg-slate-200 animate-pulse rounded" />
                <div className="h-4 w-36 bg-slate-200 animate-pulse rounded" />
              </div>
              <div className="divide-y">
                {[...Array(3)].map((_, i) => (
                  <div key={i} className="p-4">
                    <div className="flex items-center justify-between mb-2">
                      <div className="h-5 w-48 bg-slate-200 animate-pulse rounded" />
                      <div className="h-5 w-20 bg-slate-200 animate-pulse rounded" />
                    </div>
                    <div className="flex items-center justify-between">
                      <div className="h-4 w-32 bg-slate-200 animate-pulse rounded" />
                      <div className="h-4 w-24 bg-slate-200 animate-pulse rounded" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
